import I18n from 'I18n';
import keyMirror from 'react-utils/keyMirror';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
export const DependentFieldPanelType = keyMirror({
  NEW: null,
  EDIT: null
});
export const DependentFieldOperator = {
  EQ: 'EQ',
  NEQ: 'NEQ',
  CONTAINS: 'CONTAINS',
  DOESNT_CONTAIN: 'DOESNT_CONTAIN',
  STR_STARTS_WITH: 'STR_STARTS_WITH',
  STR_ENDS_WITH: 'STR_ENDS_WITH',
  LT: 'LT',
  LTE: 'LTE',
  GT: 'GT',
  GTE: 'GTE',
  BETWEEN: 'BETWEEN',
  NOT_BETWEEN: 'NOT_BETWEEN',
  WITHIN_TIME: 'WITHIN_TIME',
  WITHIN_TIME_REVERSE: 'WITHIN_TIME_REVERSE',
  SET_ANY: 'SET_ANY',
  SET_NOT_ANY: 'SET_NOT_ANY',
  SET_ALL: 'SET_ALL',
  SET_NOT_ALL: 'SET_NOT_ALL',
  SET_EQ: 'SET_EQ',
  SET_NEQ: 'SET_NEQ',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY'
};
export const getDependentFieldOperatorLabel = operator => I18n.text(`editor.form.config.dependentFields.operators.${operator}`);
const TEXT_OPERATORS = [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.CONTAINS, DependentFieldOperator.DOESNT_CONTAIN, DependentFieldOperator.STR_STARTS_WITH, DependentFieldOperator.STR_ENDS_WITH, DependentFieldOperator.IS_NOT_EMPTY];
const ENUMERATION_OPERATORS = [DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.IS_NOT_EMPTY];
export const DependentFieldOperatorsByFieldType = {
  [FieldTypes.TEXT]: TEXT_OPERATORS,
  [FieldTypes.TEXTAREA]: [DependentFieldOperator.CONTAINS, DependentFieldOperator.DOESNT_CONTAIN, DependentFieldOperator.STR_STARTS_WITH, DependentFieldOperator.STR_ENDS_WITH, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.RADIO]: ENUMERATION_OPERATORS,
  [FieldTypes.SELECT]: ENUMERATION_OPERATORS,
  [FieldTypes.CHECKBOX]: [DependentFieldOperator.SET_EQ, DependentFieldOperator.SET_NEQ, DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.SET_ALL, DependentFieldOperator.SET_NOT_ALL, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.SINGLE_CHECKBOX]: [DependentFieldOperator.EQ, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.DATE]: [DependentFieldOperator.EQ, DependentFieldOperator.LT, DependentFieldOperator.GT, DependentFieldOperator.BETWEEN, DependentFieldOperator.NOT_BETWEEN, DependentFieldOperator.WITHIN_TIME_REVERSE, DependentFieldOperator.WITHIN_TIME, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.NUMBER]: [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.LT, DependentFieldOperator.LTE, DependentFieldOperator.GT, DependentFieldOperator.GTE, DependentFieldOperator.BETWEEN, DependentFieldOperator.NOT_BETWEEN, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.PHONE_NUMBER]: [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.LT, DependentFieldOperator.LTE, DependentFieldOperator.GT, DependentFieldOperator.GTE, DependentFieldOperator.IS_NOT_EMPTY, DependentFieldOperator.CONTAINS, DependentFieldOperator.DOESNT_CONTAIN],
  [FieldTypes.FILE]: [DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.PAYMENT_RADIO]: ENUMERATION_OPERATORS,
  [FieldTypes.SUBMIT]: TEXT_OPERATORS,
  [FieldTypes.PHONE]: TEXT_OPERATORS,
  [FieldTypes.MOBILE_PHONE]: TEXT_OPERATORS
};
export const DependentFieldValidationType = keyMirror({
  OPERATOR_REQUIRED: null,
  VALUE_REQUIRED: null,
  FIELD_REQUIRED: null
});